import { Dispatch, SetStateAction } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createStyles, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import { RootState } from 'store';
import { highlightErrors } from 'store/modules/notaComercial';
import { resetMetadata } from 'store/modules/notaComercial/caracteristicas';
import { resetCriteriosRemuneracao } from 'store/modules/notaComercial/criteriosRemuneracao';
import { resetEventos } from 'store/modules/notaComercial/eventos';
import { resetDocuments } from 'store/modules/notaComercial/uploadDocumentos';
import { Button, MdSpace, SmSpace } from 'm2m.components';
import { dataAditamentoReset, uploadDocumentoAditamentoReset } from 'store/modules/notaComercial/aditamento';
import { TipoRegistroInstrumentoFinanceiro } from 'common/genericTypes';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconWrapper: {
      width: '112px',
      height: '112px',
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    icon: {
      width: '40px',
      height: '40px',
    },
  })
);

export function Finished({
  setActiveStep,
  setFinished,
  handleReturn,
  codigoNotaComercial,
  ticket
}: {
  setActiveStep: Dispatch<SetStateAction<number>>;
  setFinished: Dispatch<SetStateAction<boolean>>;
  handleReturn: () => void;
  codigoNotaComercial: string;
  ticket?: string;
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const typeOfRegister = useSelector((state: RootState) => state.notaComercialCadastro.typeOfRegister);

  function handleReset() {
    dispatch(resetMetadata());
    dispatch(resetCriteriosRemuneracao());
    dispatch(resetEventos());
    dispatch(resetDocuments());
    dispatch(uploadDocumentoAditamentoReset());
    dispatch(dataAditamentoReset());
    dispatch(highlightErrors(false));
    setActiveStep(0);
    setFinished(false);
    handleReturn();
  }

  const defineComponent = () => {
    switch (typeOfRegister) {
      case TipoRegistroInstrumentoFinanceiro.Cadastro:
        return (
          <div>
            <Grid container direction="column" justifyContent="center" alignItems="center">
              <div className={classes.iconWrapper}>
                <CheckCircleIcon className={classes.icon} color="secondary" />
              </div>
              <SmSpace />
              <Typography variant="h3">{`Cadastro de Instrumento Financeiro concluído com sucesso!`}</Typography>
              <SmSpace />
              <Typography variant="body2">
                {`Sua solicitação está sendo analisada pela área responsável. ${ticket ? `O ticket desse instrumento financeiro é ${ticket}.` : ''}`}
              </Typography>
              <MdSpace />
              <div style={{ display: 'flex' }}>
                <Button onClick={handleReset} variant="contained" color="primary">
                  {'Voltar para a página inicial'}
                </Button>
              </div>
              <MdSpace />
            </Grid>
          </div>
        );
      case TipoRegistroInstrumentoFinanceiro.Edicao:
        return (
          <div>
            <Grid container direction="column" justifyContent="center" alignItems="center">
              <div className={classes.iconWrapper}>
                <CheckCircleIcon className={classes.icon} color="secondary" />
              </div>
              <SmSpace />
              <Typography variant="h3">{`Edição de Instrumento Financeiro concluída com sucesso!`}</Typography>
              <MdSpace />
              <div style={{ display: 'flex' }}>
                <Button onClick={handleReset} variant="contained" color="primary">
                  {'Voltar para a página inicial'}
                </Button>
              </div>
              <MdSpace />
            </Grid>
          </div>
        );
      case TipoRegistroInstrumentoFinanceiro.EdicaoEmitido:
        return (
          <div>
            <Grid container direction="column" justifyContent="center" alignItems="center">
              <div className={classes.iconWrapper}>
                <CheckCircleIcon className={classes.icon} color="secondary" />
              </div>
              <SmSpace />
              <Typography variant="h3">{`Edição de Instrumento Financeiro concluída com sucesso!`}</Typography>
              <MdSpace />
              <div style={{ display: 'flex' }}>
                <Button onClick={handleReset} variant="contained" color="primary">
                  {'Voltar para a página inicial'}
                </Button>
              </div>
              <MdSpace />
            </Grid>
          </div>
        );
      case TipoRegistroInstrumentoFinanceiro.Aditamento:
        return (
          <div>
            <Grid container direction="column" justifyContent="center" alignItems="center">
              <div className={classes.iconWrapper}>
                <CheckCircleIcon className={classes.icon} color="secondary" />
              </div>
              <SmSpace />
              <Typography variant="h3">
                {`Pedido de Aditamento do Instrumento Financeiro concluído com sucesso!`}
              </Typography>
              <SmSpace />
              <Typography variant="body2">
                {`Sua solicitação está sendo analisada pela área responsável. O código deste Instrumento Financeiro é ${codigoNotaComercial}.`}
              </Typography>
              <Typography variant="body2">{`Você pode gerar o termo constitutivo para esse instrumento.`}</Typography>
              <MdSpace />
              <div style={{ display: 'flex' }}>
                <Button onClick={handleReset} variant="contained" color="primary">
                  {'Voltar para a página inicial'}
                </Button>
              </div>
              <MdSpace />
            </Grid>
          </div>
        );
      default:
        return <p>Loading</p>;
    }
  };
  return defineComponent();
}
